import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export type FontIconProps = {
  id?: string;
  testId?: string;
  title?: string;
  iconName: TUNDR_ICONS;
  clickable?: boolean;
  boxed?: boolean;
  disabled?: boolean;
  rotation?: 0 | 90 | 180 | 270;
  size?: FontIconSize;
};

export enum FontIconSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  '2XL' = '2xl',
  '3XL' = '3xl',
}
